import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';

ProgramsCombosController.$inject = ['$scope'];

function ProgramsCombosController($scope: IScope & { programsCombos: TODO }) {
  const ctrl = {
    model: 'Your spankin new application.programs.combos.default view!',

    init: function () {},

    success: {
      init: function (response) {},
    },

    error: {
      init: function (response) {},
    },
  };

  $scope.programsCombos = ctrl;
  ctrl.init();
}

export const ProgramsCombosControllerModule = angular
  .module('acme.view.application.programs.combos.controllers', [])
  .controller('ProgramsCombosController', ProgramsCombosController).name;
